const digest = '17489bd0c858cfad23d465f9a249adf620fce722e6c9159b4be3f4e19b9f57dd';
const css = `@media (max-width:800px){._carousel_nf5au_2 div[role=group]{padding-left:0;padding-right:0}}@media (min-width:800px) and (max-width:1023px){._carousel_nf5au_2 div[role=group]{margin-right:.5rem;padding-left:0}._carousel_nf5au_2 div[role=group]:nth-child(3n+3){margin-left:-.5rem}._carousel_nf5au_2 div[role=group]:nth-child(2n+2){margin-right:0}}@media (min-width:1024px){._carousel_nf5au_2 div[role=group]{margin-right:.5rem;padding-left:0}._carousel_nf5au_2 div[role=group]:nth-child(4n+4){margin-left:-1rem}._carousel_nf5au_2 div[role=group]:nth-child(3n+3){margin-right:0}}._carousel_nf5au_2 a:focus{outline:unset}._carousel_nf5au_2 a div:first-child{box-shadow:none;--tw-shadow:none}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'carousel': '_carousel_nf5au_2' };
export const carousel = '_carousel_nf5au_2';
export { css, digest };